import {Component, Input, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {LawyerInfoCreateComponent} from './lawyer-info-create/lawyer-info-create.component';
import {LawyerInfoUnlinkComponent} from './lawyer-info-unlink/lawyer-info-unlink.component';


@Component({
  selector: 'app-lawyer-info',
  templateUrl: './lawyer-info.component.html',
  styleUrls: ['./lawyer-info.component.scss']
})

export class LawyerInfoComponent implements OnInit{
  @Input() property: any;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  openCreateLawyerInfoDialog() {
    const dialogRef = this.dialog.open(LawyerInfoCreateComponent, {
      width: '90%',
      maxWidth: '1000px',
      data: {property: this.property},
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.code === 1) {
        this.property.lawyer = result.lawyer;
      }
    });
  }

  openEditLawyerDialog(lawyer) {
    // this.dialog.open(LawyerInfoEditComponent, {
    //   width: '90%',
    //   maxWidth: '1000px',
    //   data: {lawyer}
    // });
  }

  openUnlinkLawyerDialog(lawyer) {
    const dialogRef = this.dialog.open(LawyerInfoUnlinkComponent, {
      width: '90%',
      maxWidth: '500px',
      data: {lawyer, property: this.property}
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result && result.code === 1) {
        this.property.lawyer = null;
      }
    });
  }



}
